export enum ActiveMetricTabs {
  Impression = 'Impression',
  Conversion = 'Conversion',
}
